/**
 * <cart-empty-cta>: wraps the empty-cart button. When the homepage offer is on
 * this page, it closes the cart drawer and glides to the offer instead of
 * reloading. Elsewhere the link navigates to the homepage offer as usual.
 */
class CartEmptyCta extends HTMLElement {
  connectedCallback() {
    this.onClick = (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
      const hash = new URL(link.href, window.location.href).hash;
      const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
      if (!target) return;
      event.preventDefault();
      const dialog = this.closest('dialog');
      if (dialog && dialog.open) dialog.close();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    };
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('cart-empty-cta')) customElements.define('cart-empty-cta', CartEmptyCta);
